/*
 *
 * # Example of usage:
 *
 * 1 - Using all props
 * <ExpandBox title="Example titlme" onClick={this.handleClick} expanded={this.state.expanded} boxHeight="20px">
 *  CHILDREN
 * </ExpandBox>
 *
 *
 * Note: You need a component with handleClick and state.expanded
 */

"use strict";

var cx = require("classnames");
var Icon = require("app/shared/components/Icon/icon");

var ExpandBox = React.createClass({
  propTypes: {
    children: React.PropTypes.node.isRequired,
    onClick: React.PropTypes.func.isRequired,
    title: React.PropTypes.string.isRequired,
    titleClass: React.PropTypes.string,
    boxHeight: React.PropTypes.string.isRequired,
    expanded: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      customIcon: true,
      icon: "chevron-down",
      expanded: false,
      titleClass: "btn btn-primary w-100pct"
    };
  },

  handleOnClick: function(e) {
    this.props.onClick(e);
  },

  render: function(){
    var iconClass = cx(this.props.icon, {
      "tr-180": this.props.expanded,
      "expandBox-icon": true
    });

    var boxClass = cx("expandBox-body", "lh-initial", {
      "p-15": this.props.expanded
    });

    var boxHeight = cx({
      [`${this.props.boxHeight}`]: this.props.expanded
    });

    return (
      <div className="ovf-h u-boxShadow-light">
        <div className={this.props.titleClass} onClick={this.handleOnClick}>
          <span>{this.props.title}</span>
          <Icon icon={iconClass} custom={this.props.customIcon} />
        </div>
        <div className={boxClass} style={{height: boxHeight}}>
          { this.props.children }
        </div>
      </div>
    );
  }
});

module.exports = ExpandBox;



// WEBPACK FOOTER //
// ./app/shared/components/ExpandBox/expand-box.jsx